import React from "react";
import { Slide } from "@mui/material";
import { Alert } from "@mui/material";
import { Snackbar } from "@mui/material";
import { HiOutlineBellAlert } from "react-icons/hi2";

const CapsLockSnackbar = ({open}) => {

  return (
    <div>

    <Snackbar
  open={open}
  anchorOrigin={{
    vertical: "top",
    horizontal: "left",
  }}
>
  <Slide in={open} mountOnEnter unmountOnExit>
    <Alert
      severity="warning"
      icon={<HiOutlineBellAlert />}
      sx={{
        width: "100%",
        backgroundColor: "#ff5722",
        borderRadius: "30px",
        padding: "10px",
        color: "#000", // Optional: midabka qoraalka
        fontFamily: "Exo 2",
        padding: "3px 15px 3px 15px",
        alignItems: "center",
        "& .MuiAlert-icon": {
          fontSize: "1.2rem", // Cabbirka icon-ka
          color: "#000", // Optional: midabka qoraalka
          marginRight: '7px',
        },
      }}

      
    >
      CAPS LOCKED — FARTA WAA-WEYN AYAA KUU FURAN
    </Alert>
  </Slide>
</Snackbar>



  </div>
  );
};

export default CapsLockSnackbar;